import * as React from 'react';
interface IDefaultLnRouterTableColumnOptions {
    sortable: boolean,
    headerGroup: string | undefined,
    enabled: boolean,
    headerAlign: 'right' | 'left',
    headerComponent: (column: LnRouterTableColumn<any>) => any
}

const DefaultLnRouterTableColumnOptions: IDefaultLnRouterTableColumnOptions = {
    sortable: false,
    headerGroup: undefined,
    enabled: true,
    headerAlign: 'right',
    headerComponent: (column: LnRouterTableColumn<any>) => {
        const alignment = column.options.headerAlign === 'right'? 'text-right': '';
        return <div className={'px-2 light:hover:text-viking-800 ' + alignment}>{column.label}</div>
    }
}

export interface LnRouterRendererProps<T> {
    value: any,
    row: {
        original: T
    }
}

export class LnRouterTableColumn<T> {
    public options: typeof DefaultLnRouterTableColumnOptions;
    constructor(
        public label: React.ReactElement | string,
        public valuePath: string, // Path like peer.medianPpm
        public renderer: (props: LnRouterRendererProps<T>) => any,
        options: Partial<IDefaultLnRouterTableColumnOptions> = {}
    ) {

        this.options = Object.assign({}, DefaultLnRouterTableColumnOptions, options);
    }

    get key(): string {
        return this.valuePath;
    }

    get headerGroupComponent() {
        return <div className={'px-2'}>{this.options.headerGroup}</div>
    }

    get reactTable() {
        const ret = {
            id: this.valuePath,
            Header: this.options.headerComponent(this),
            accessor: this.valuePath,
            Cell: (props) => <div className="px-2">
                {this.renderer(props)}
            </div>,
            disableSortBy: !this.options.sortable,
            align: this.options.headerAlign
        };
        if (!this.renderer) {
            delete ret.Cell
        }
        return ret;
    }

}
